// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$constantApiService = {
      async getFromMemberSystem() {
        const url = `${process.env.VUE_APP_MEMBER_API_URL}/constants`
        const response = await axios.get(url)
        return response.data
      }
    }
  }
}
